import React, { useState } from "react";
import "react-day-picker/dist/style.css";
import "./style.scss";
import { BiInfoCircle } from "react-icons/bi";
import HtmlTooltip from "@mui/material/Tooltip";
import { AiOutlineIdcard } from "react-icons/ai";
import useExerciseInfo from "../../ScheduleExercise/exerciseInfo/useExerciseInfo";
import { calculateRemainingEntrances } from "../../../utils/TicketPassHelper";
import { Exercise } from "../../../models/Exercise";
import { IoMdCheckmark } from "react-icons/io";
import { IoPersonAddOutline } from "react-icons/io5";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";
import { useTranslation } from "react-i18next";
import format from "date-fns/format";
import EAIconButton from "../../shared/Buttons/EAIconButton";
import EAButton from "../../shared/Buttons/EAButton";
import EAAlert from "../../shared/EAAlert";
import EADivider from "../../shared/EADivider";
import EAModal from "../../shared/Modal/EAModal";
interface IProps {
  asignByPass: (assignType: boolean, passId: number) => void;
  exerciseDetails?: Exercise;
  alertCalendar: string;
}
const CalendarPassReservaton: React.FC<IProps> = ({ asignByPass, exerciseDetails, alertCalendar }: IProps) => {
  const { availablePasses } = useExerciseInfo();
  const isDesktop = useDesktopSize();
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      {availablePasses && (
        <>
          {alertCalendar && <EAAlert message={alertCalendar} type="error" />}

          <EADivider />
          {availablePasses.map((item, index) => (
            <div key={index}>
              {item.ticket === false && item.passtype === 2 && (
                <div className={"pass-line ticket-line flex-between-center"}>
                  <div className="ticket-line-left flex-start-center">
                    <div className="flex-between-center">
                      <AiOutlineIdcard className="ticket-line-icon" />
                      <b>{item.name}</b>
                    </div>
                    <>
                      {item.description.length > 2 && (
                        <>
                          {isDesktop ? (
                            <HtmlTooltip
                              placement="right"
                              arrow={true}
                              title={
                                <>
                                  <div className="tooltip-description">
                                    <div>
                                      <p>
                                        Nazwa karnetu: <b>{item.name}</b>
                                      </p>
                                      <p>
                                        Pozostała ilość rezerwacji: <b>{calculateRemainingEntrances(item)}</b>
                                      </p>
                                      <p>
                                        Karnet ważny:{" "}
                                        <b>
                                          {format(item.validfrom, "dd.MM")} - {format(item.validto, "dd.MM.yyyy")}
                                        </b>
                                      </p>
                                    </div>
                                  </div>
                                </>
                              }
                            >
                              <b>
                                <BiInfoCircle className="tooltip-icon" />
                              </b>
                            </HtmlTooltip>
                          ) : (
                            <EAIconButton
                              title=""
                              icon={<BiInfoCircle className="tooltip-icon" />}
                              variant="icon"
                              onClick={() => setOpen(!open)}
                            />
                          )}
                        </>
                      )}
                    </>
                  </div>
                  <div className="ticket-line-right flex-end-center">
                    {exerciseDetails && (
                      <>
                        {exerciseDetails.assigned ? (
                          <>
                            <HtmlTooltip
                              placement="top-start"
                              title={
                                <>
                                  <article
                                    className="tooltip-description"
                                    dangerouslySetInnerHTML={{ __html: "Kliknij, aby zrezygnować z tej rezerwacji." }}
                                  ></article>
                                </>
                              }
                            >
                              <EAButton
                                title="Jesteś zapisany"
                                onClick={() => asignByPass(true, item.objectId)}
                                startIcon={<IoMdCheckmark className="icon" />}
                              />
                            </HtmlTooltip>
                          </>
                        ) : (
                          <>
                            {calculateRemainingEntrances(item) > 0 ? (
                              <EAButton
                                variant="outlined"
                                title="Zapisz się karnetem"
                                onClick={() => asignByPass(false, item.objectId)}
                                startIcon={<IoPersonAddOutline />}
                              />
                            ) : (
                              <EAButton
                                disabled
                                title="Wykorzystano"
                                onClick={() => asignByPass(false, item.objectId)}
                                startIcon={<IoPersonAddOutline />}
                              />
                            )}
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              )}
              <EAModal
                isOpen={open}
                onClose={() => setOpen(false)}
                title={item.name}
                hideButtons
                acceptButtonLabel={t("przeczytalem")}
              >
                {item.description.length > 1 ? (
                  <p className="news-modal-body" dangerouslySetInnerHTML={{ __html: item.description }}></p>
                ) : (
                  <p className="news-modal-body">{t("brak_opisu")}</p>
                )}
              </EAModal>
            </div>
          ))}
        </>
      )}
    </>
  );
};

export default CalendarPassReservaton;
